import get from 'lodash.get';

const getGTM = (rootState) => get(rootState, 'config.service.common.google-tag-manager');

export default getGTM;
